
import { useQuery} from '@apollo/client';

import { GET_ME } from '../queries/getMe';

export const useIsTeacher = () => {
  const { loading: meLoading , error: meError , data: me } = useQuery(GET_ME);

  return !meLoading && !meError && !!me?.me?.organisation?.membership?.isTeacherPersona;
};

/**
 * Whether the stripped-down phone experience is the right one — i.e. taking registers is all
 * this person does here.
 *
 * **Use this, not `useIsTeacher`, for anything that hides UI.** `isTeacherPersona` behind that
 * hook never asks whether anybody teaches: it is "not an administrator, and sees 40 or fewer
 * active courses", which is true of a companion, a class builder, a centre manager, and anybody
 * with no courses at all. `MobileContainer` used it to drop the navigation drawer entirely, so
 * nearly every non-administrator got no menu on a phone — and the per-entry gates inside that
 * menu never ran, which is how somebody holding `CREATE_PERSON` ended up with no way to reach
 * the form it unlocks.
 *
 * `useIsTeacher` stays because `isTeacherPersona` stays: both native apps gate their supervisor
 * UI on it and cannot change without a release.
 */
export const useIsTeacherOnly = () => {
  const { loading: meLoading, error: meError, data: me } = useQuery(GET_ME);

  return !meLoading && !meError && !!me?.me?.organisation?.membership?.isTeacherOnly;
};
